module.exports = __webpack_public_path__ + "img/yema_logo.b63b3ef2.png";